import { Grid } from '@mui/material';
const HangaroudPreview = ({ profile }) => {
  const { emp, trips } = profile;
  return (
    <>
      <h3>Hangaround</h3>
      <p>
        <strong>Return Flight Ticket:</strong> {emp.returnFlightTicket || 'N/A'}
      </p>
      <Grid container spacing={2} style={{ padding: '20px' }}>
        <Grid item xs={12} sm={12}>
          <strong>Previous Clients</strong>
          <div style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '8px' }}>
            <ul style={{ padding: 0 }}>
              {trips && trips.length > 0 ? (
                trips.slice(0, 3).map((trip, index) => (
                  <li key={index} style={{ marginBottom: '10px' }}>
                    {trip.client} - [{trip.projectName}]
                  </li>
                ))
              ) : (
                <p>No trips available.</p>
              )}
            </ul>
          </div>
        </Grid>
      </Grid>
    </>
  );
};
export default HangaroudPreview;
